import { $_DKD, $_GCD, $_CD } from '@/confs/common.const.js';
import commonApi from "@/apis/common.api.js";
import gripUtil from "@/libs/grip.util";

export default {
    state: {
        // 부서 리스트
        ssovDeptList: [],
        // 사용자 리스트
        ssovUserList: [],
        // 팀정보
        teamList: [],
        // 정/현원
        deptLimitList: [],
        // 선택 부서
        selectedDept: '',
        // 선택 실국
        selectedBureau: '',
        // 선택 사용자
        selectedUser: {},
        // 팝업
        showOrganizationWin: false,
        // 정현원현황
        memberInfoList:[],
        // 구 정현원현황 (행정국 대기자 포함)
        guMemberInfoList:[],
        // 동 정현원현황
        dongMemberInfoList:[],
    },
    getters: {
        getSsovDeptList: function(state) {
            return state.ssovDeptList;
        },
        getSsovUserList: function(state) {
            return state.ssovUserList;
        },
        // getTeamList: function(state) {
        //     return state.teamList;
        // },
        // getDeptLimitList: function(state){
        //     return state.deptLimitList;
        // },
        // getSelectedDept: function(state) {
        //     return state.selectedDept;
        // },
        // getSelectedBureau: function(state) {
        //     return state.selectedBureau;
        // },
        // getSelectedUser: function(state) {
        //     return state.selectedUser;
        // },
        // getShowOrganizationWin: function(state) {
        //     return state.showOrganizationWin;
        // },
        // getMemberInfoList: function(state) {
        //     return state.memberInfoList;
        // },
        // getGuMemberInfoList: function(state) {
        //     return state.guMemberInfoList;
        // },
        // getDongMemberInfoList: function(state) {
        //     return state.dongMemberInfoList;
        // },
    },
    mutations: {
        SSOV_DEPT_LIST: function(state, ssovDeptList) {
            state.ssovDeptList = ssovDeptList;
        },
        SSOV_USER_LIST: function(state, ssovUserList) {
            state.ssovUserList = ssovUserList;
        },
        // TEAM_LIST: function(state, teamList) {
        //     state.teamList = teamList;
        // },
        // DEPT_LIMIT_LIST: function(state, deptLimitList) {
        //     state.deptLimitList = deptLimitList;
        // },
        // SELECTED_DEPT: function(state, selectedDept) {
        //     state.selectedDept = selectedDept;
        // },
        // SELECTED_BUREAU: function(state, selectedBureau) {
        //     state.selectedBureau = selectedBureau;
        // },
        // SELECTED_USER: function(state, selectedUser) {
        //     state.selectedUser = selectedUser;
        // },
        // SHOW_ORGANIZATION_WIN: function(state, showOrganizationWin) {
        //     state.showOrganizationWin = showOrganizationWin;
        // },
        // MEMBER_INFO_LIST: function(state, memberInfoList) {
        //     state.memberInfoList = memberInfoList;
        // },
        // GU_MEMBER_INFO_LIST: function(state, guMemberInfoList) {
        //     state.guMemberInfoList = guMemberInfoList;
        // },
        // DONG_MEMBER_INFO_LIST: function(state, dongMemberInfoList) {
        //     state.dongMemberInfoList = dongMemberInfoList;
        // },
    },
    actions: {
        // 조직도 - 부서정보
        FETCH_SSOV_DEPT_LIST: function(context, q) {
            return commonApi.fetchSsovDeptList(q)
                .then(function(res) {
                    let deptList = res.data.data;
                    deptList = deptList.filter(function(dept) {
                        if(dept.deptRank !== null) {
                            if(dept.deptRank !== '') {
                                return dept;
                            }
                        }
                    }.bind(this));
                    context.commit('SSOV_DEPT_LIST', deptList);
                })
                .catch(function(error) {
                    console.log(error)
                });
        },

        // 조직도 - 직원정보
        FETCH_SSOV_USER_LIST: function(context, q) {
            return commonApi.fetchSsovUserList(q)
                .then(function(res) {
                    context.commit('SSOV_USER_LIST', res.data);
                })
                .catch(function(error) {
                    console.log(error)
                });
        },

        // 조직도 - 팀정보
        // FETCH_TEAM_LIST: function(context, q) {
        //     return _CommonApi.fetchReposDataList(_DKD.TEAM_LIST)
        //         .then(function(res) {
        //             context.commit('TEAM_LIST', res.data);
        //         })
        //         .catch(function(error) {
        //             console.log(error)
        //         });
        // },

        // 정현원
        // FETCH_DEPT_LIMIT_LIST: function(context, q) {
        //     return _CommonApi.fetchReposDataList(_DKD.DEPT_LIMIT)
        //         .then(function(res) {
        //             context.commit('DEPT_LIMIT_LIST', res.data);
        //         })
        //         .catch(function(error) {
        //             console.log(error)
        //         });
        // },

        // SET_SELECTED_DEPT: function(context, selectedDept) {
        //     context.commit("SELECTED_DEPT", selectedDept);
        // },
        // SET_SELECTED_BUREAU: function(context, selectedBureau) {
        //     context.commit("SELECTED_BUREAU", selectedBureau);
        // },
        // SET_SELECTED_USER: function(context, selectedUser) {
        //     context.commit("SELECTED_USER", selectedUser);
        // },
        // SET_SHOW_ORGANIZATION_WIN: function(context, showOrganizationWin) {
        //     context.commit("SHOW_ORGANIZATION_WIN", showOrganizationWin);
        // },
        // FETCH_MEMBER_INFO_LIST: function(context, memberInfoList) {
        //     return _CommonApi.fetchCodeListByCodeGroup(_CD.TOTAL_DEPT_CODE)
        //         .then(function(res) {
        //             let hjdMap = _CommonApi.toDict(res.data, 'commonCode');
        //             return _CommonApi.fetchMaxDataList(_DKD.GROUP_MEMBER, 'basdt_val')
        //                 .then(function(res) {
        //                     let memberList = [];
        //                     if(typeof res.data !== 'undefined') {
        //                         res.data.forEach(function(d){
        //                             d.seq = hjdMap[d.val1].seq;
        //                         });
        //                         memberList = res.data.sort(function(first, second) {
        //                             return Number(first.seq) - Number(second.seq);
        //                         });
        //                         memberList = memberList.sort(function(first, second) {
        //                             if(first.seq === second.seq) {
        //                                 return first.val2 - second.val2;
        //                             }
        //                         })
        //                     }
        //                     let guList = memberList.filter(function(data) {
        //                         return data.valNm1.slice(-1) !== "동";
        //                     });
        //                     let dongList = memberList.filter(function(data) {
        //                         return data.valNm1.slice(-1) === "동";
        //                     });
        //                     context.commit("GU_MEMBER_INFO_LIST", guList);
        //                     context.commit("DONG_MEMBER_INFO_LIST", dongList);
        //                     context.commit("MEMBER_INFO_LIST", memberList);
        //                 })
        //         })
        // },
    },
}


